export default __webpack_public_path__ + "static/media/target-white.66b95bdd.svg";